import { render, staticRenderFns } from "./ContractDiscounts.vue?vue&type=template&id=34962a4d&"
import script from "./ContractDiscounts.vue?vue&type=script&lang=js&"
export * from "./ContractDiscounts.vue?vue&type=script&lang=js&"
import style0 from "./ContractDiscounts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports